import React from 'react'

const RelativeError = ({ children, errorClass = '' }) => (
  <div className={`${errorClass} relative-error`}>{children}</div>
)

export default RelativeError
